import {
  Radio,
  RadioGroup,
  Text
} from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FilterRow, { FilterGroup } from '../../reusable/Layout';

const TRANSACTION_TYPES = [
  { id: 'REGULAR_RETURNS', label: 'RL_RegularSaleReturn', value: 'RetailTransaction' },
  { id: 'RETURNS', label: 'RL_Returns', value: 'Return' },
  { id: 'NO_SALE', label: 'RL_NoSale', value: 'NoSale' },
  { id: 'MEDIA_EXCHANGE', label: 'RL_MediaExchange', value: 'StoredValueTransaction' },
];

const TransactionType = ({ onFilterValueChange, translations }) => {
  const { transactionType } = useSelector((state) => state.nposFilters);

  return (
    <FilterGroup>
      <FilterRow>
        <Text className="filter-name">{translations.RL_TransactionType}</Text>
        <div className="d-sm-flx flx-dir-sm-r" style={{ gap: '12px' }}>
          <RadioGroup
            data-testid="transaction-type-radio-group"
            id="transactionType"
            name="radio-button-group"
            valueSelected={transactionType}
            onChange={(e) => onFilterValueChange({ id: 'transactionType', value: e.target.value })}
          >
            {TRANSACTION_TYPES.map(({ id, label, value }) => (
              <Radio
                key={id}
                data-testid={`transaction-type-radio-${id}`}
                id={id}
                label={translations[label]}
                value={value}
              />
          ))}
          </RadioGroup>
        </div>
      </FilterRow>
    </FilterGroup>
);
};

TransactionType.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default TransactionType;
